export const  defaultTouchSpinData = [
    { id: 1, value: 0, color: "primary" },
    { id: 2, value: 2, color: "secondary" },
    { id: 3, value: 1, color: "success" },
    { id: 4, value: 8, color: "danger" },
    { id: 5, value: 3, color: "warning" },
    { id: 6, value: 9, color: "info" },
    { id: 7, value: 4, color: "dark" },
  ];

  export const touchSpinData = [
    {
      text: "Use the ",
      code: ".decrement-touchspin ",
    },
    {
      text: "and ",
      code: ".increment-touchspin ",
    },
    {
      text: "class.",
    },
  ];
  